import { DumpsterEventsOutputItem } from "@veritas-dumpsters/models/dumpster-events";
import { ConstantHelper } from "@veritas-shared/helpers/constant.helper";
import { GridColumn } from "@veritas-shared/models/grid-column";

export class ColumnEvents {
  constructor(
    public constantHelper: ConstantHelper
  ) { }

  public payloadType = (
    detailsFunc: (event: DumpsterEventsOutputItem) => void
  ): GridColumn => ({
    field: 'payloadType',
    title: 'common.Type',
    sortable: true,
    resizable: true,
    filterable: true,
    display: 'link',
    callback: detailsFunc
  });

  public timestamp = (): GridColumn => ({
    field: 'timestamp',
    title: 'vocabulary.TimeLine.Date',
    sortable: true,
    resizable: true,
    filterable: true,
    filter: 'date',
    display: 'date',
    dateType: this.constantHelper.DATE_TIME_FORMAT,
  });

  public messageType = (): GridColumn => ({
    field: 'messageType',
    title: 'component.ImportLog.Message',
    sortable: true,
    resizable: true,
    filterable: false,
    display: 'text',
  });
}